export default "__VITE_ASSET__uLJc6Mtz__"